import { render, staticRenderFns } from "./AuthOtpDeliveryComponent.vue?vue&type=template&id=42872d9f&scoped=true"
import script from "./AuthOtpDeliveryComponent.vue?vue&type=script&lang=js"
export * from "./AuthOtpDeliveryComponent.vue?vue&type=script&lang=js"
import style0 from "./AuthOtpDeliveryComponent.vue?vue&type=style&index=0&id=42872d9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42872d9f",
  null
  
)

export default component.exports